const controls = [
	{ value: 1, name: "Next Page" },
	{ value: 2, name: "Previous Page" },
	{ value: 4, name: "Exit Screen" },
];

export default controls;
